export default "__VITE_ASSET__CZJyC6H6__"